import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=4c933f1f&scoped=true&"
import script from "./navigation.vue.js?vue&type=script&lang=js&"
export * from "./navigation.vue.js?vue&type=script&lang=js&"
import style0 from "./navigation.vue?vue&type=style&index=0&id=4c933f1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c933f1f",
  null
  
)

export default component.exports